import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { Typography } from "@circle-react/components/shared/uikit/Typography";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface DeletedImagePlaceholderProps {
  isSquareGrid?: boolean;
}

export const DeletedImagePlaceholder = ({
  isSquareGrid = true,
}: DeletedImagePlaceholderProps) => (
  <div
    className={classNames(
      "bg-secondary flex items-center justify-center rounded-md md:rounded-none",
      {
        "aspect-square": isSquareGrid,
        "min-h-48": !isSquareGrid,
      },
    )}
  >
    <div className="flex flex-col items-center justify-center p-6 text-center">
      <div className="mb-2">
        <Icon type="16-trash-bin-2" size={20} />
      </div>
      <Typography.BodyXs color="light">
        {t("image_space.file_not_found")}
      </Typography.BodyXs>
    </div>
  </div>
);
